<template>
  <div class="proctor-guidelines">
    <div class="setup-text color_ash">
      Please read carefully. For more information about how Gradely proctoring,
      Please check this article on
      <router-link to class="btn-link link-no-underline"
        >Proctored examination.</router-link
      >
    </div>

    <div class="guidelines-block">
      <div class="display-block rounded-5 overflow-hidden position-relative">
        <ul class="guidelines-list list-unstyled">
          <li><span>•</span> You must be alone in the room</li>
          <li>
            <span>•</span> You are not allowed to read out loud any questions or
            answer
          </li>
          <li>
            <span>•</span> You desk is clean and in line with the assessment
            regulations
          </li>
          <li>
            <span>•</span> You will have my camera, speaker and microphone on
            throughout the assessment session
          </li>
          <li>
            <span>•</span> You will not allow any other individual attemt the
            assessment, or talk to you during the assessment.
          </li>
          <li>
            <span>•</span> You are not allowed to visit other websites during
            the assessment.
          </li>
        </ul>
      </div>

      <!-- BUTTON -->
      <div class="d-flex justify-content-center align-items-center flex-wrap">
        <button
          @click="startExam"
          class="btn btn-md btn-accent brand_navy font-weight-bold"
        >
          Start Exam
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tag: String,
  },

  methods: {
    startExam() {
      this.$emit("start-exam");
    },
  },
};
</script>

<style lang="scss">
.proctor-guidelines {
  .setup-text {
    font-size: 14.5px;
    line-height: 165%;
    margin-bottom: 15px;
  }

  .guidelines-block {
    .display-block {
      background: #f0efef;
      padding: 20px;
      width: 100%;
      height: auto;
      margin-bottom: 30px;
    }

    .guidelines-list {
      li {
        color: $color_text;
        margin-bottom: 10px;
        font-size: 14.5px;
        line-height: 19px;

        span {
          margin-right: 7px;
        }
      }
    }
  }
}
</style>
